module.exports = __webpack_public_path__ + "img/editor.5d4be01f.svg";